import React, { FC } from 'react';
import { ProjectPhaseNameChanged } from 'api/notifications/meta';
import { useTranslation } from 'hooks/use-translation';
import { ProjectPhaseFieldChangedMessage } from './project-phase-field-changed';

export const ProjectPhaseNameChangedView: FC<{
  meta: ProjectPhaseNameChanged;
}> = ({ meta: { by, from, to } }) => (
  <ProjectPhaseFieldChangedMessage
    by={by}
    name="name"
    phase={useTranslation('notifications.messages.phase')}
    from={from}
    to={to}
    normal
  />
);
